module.exports = __webpack_public_path__ + "./images/7197c843433908740aecc0d76e43e71f.webp";